import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Copy, FilePdf, ArrowsClockwise, Warning, QrCode } from "@phosphor-icons/react";
import { fileUrl } from "@/lib/api";
import { toast } from "sonner";

const copy = (v, msg = "Copiado") => { navigator.clipboard.writeText(v); toast.success(msg); };

export function InvoicePayment({ invoice, onSync }) {
  const [busy, setBusy] = useState(false);
  const isInter = invoice.provider === "INTER";

  const sync = async () => {
    if (!onSync) return;
    setBusy(true);
    try { await onSync(invoice); } finally { setBusy(false); }
  };

  if (isInter && !invoice.inter_codigo) {
    return (
      <div className="p-3 rounded border border-amber-200 bg-amber-50 text-xs text-amber-800 flex items-start gap-2" data-testid="invoice-inter-error">
        <Warning size={16} className="shrink-0 mt-0.5" />
        <div className="flex-1">
          <div className="font-medium">Boleto ainda não emitido no Banco Inter</div>
          {invoice.inter_error && <div className="mt-1 mono break-all">{invoice.inter_error}</div>}
        </div>
        {onSync && <Button size="sm" variant="outline" disabled={busy} onClick={sync} data-testid="invoice-retry-btn"><ArrowsClockwise size={12} className="mr-1" /> Tentar novamente</Button>}
      </div>
    );
  }

  return (
    <div className="space-y-3 text-sm" data-testid="invoice-payment">
      {invoice.pix_qrcode && (
        <div>
          <div className="eyebrow flex items-center gap-1"><QrCode size={12} /> PIX copia e cola</div>
          <div className="flex items-center gap-2 mt-1 bg-slate-50 border border-slate-200 rounded px-2 py-1.5">
            <span className="mono text-xs truncate flex-1" data-testid="invoice-pix-code">{invoice.pix_qrcode}</span>
            <button onClick={() => copy(invoice.pix_qrcode, "Código PIX copiado")} className="text-slate-500 hover:text-slate-900" data-testid="invoice-pix-copy"><Copy size={14} /></button>
          </div>
        </div>
      )}
      {invoice.linha_digitavel && (
        <div>
          <div className="eyebrow">Linha digitável do boleto</div>
          <div className="flex items-center gap-2 mt-1 bg-slate-50 border border-slate-200 rounded px-2 py-1.5">
            <span className="mono text-xs truncate flex-1" data-testid="invoice-linha-digitavel">{invoice.linha_digitavel}</span>
            <button onClick={() => copy(invoice.linha_digitavel, "Linha digitável copiada")} className="text-slate-500 hover:text-slate-900" data-testid="invoice-linha-copy"><Copy size={14} /></button>
          </div>
        </div>
      )}
      <div className="flex flex-wrap items-center gap-2">
        {isInter && invoice.boleto_url && (
          <a href={fileUrl(invoice.boleto_url)} target="_blank" rel="noreferrer" data-testid="invoice-pdf-link">
            <Button size="sm" className="btn-primary"><FilePdf size={14} className="mr-1" /> Baixar boleto (PDF)</Button>
          </a>
        )}
        {isInter && onSync && invoice.status !== "pago" && (
          <Button size="sm" variant="outline" disabled={busy} onClick={sync} data-testid="invoice-sync-btn">
            <ArrowsClockwise size={14} className={`mr-1 ${busy ? "animate-spin" : ""}`} /> Já paguei — atualizar
          </Button>
        )}
        {!isInter && invoice.boleto_url && (
          <div className="text-xs text-slate-500 flex items-center gap-2">
            <span>Link (simulado):</span>
            <span className="mono truncate max-w-[220px]">{invoice.boleto_url}</span>
            <button onClick={() => copy(invoice.boleto_url)}><Copy size={12} /></button>
          </div>
        )}
      </div>
      {isInter && (
        <div className="text-[10px] text-slate-400">
          Banco Inter · {invoice.inter_env === "production" ? "produção" : "sandbox (homologação)"}
          {invoice.inter_situacao ? ` · ${invoice.inter_situacao}` : ""} · a baixa é automática após o pagamento.
        </div>
      )}
    </div>
  );
}
